import domReady from '../helpers/dom-ready';

class LeftMenu {
  static init() {
    return new LeftMenu();
  }

  constructor() {
    this.menu = document.querySelector('.left-side-menu');
    this.areaLinks = document.querySelectorAll('.-has-links > button');

    if (this.areaLinks && this.areaLinks.length) {
      this.addEventListeners(this.areaLinks);
    }
  }

  addEventListeners(links) {
    [...links].forEach((link) => {
      if (link.classList.contains('-active')) {
        // eslint-disable-next-line
        link.style.maxHeight = `${link.scrollHeight}px`;
      }
      link.addEventListener('click', this.toggleMenu);
    });
  }

  toggleMenu(e) {
    const innerMenu = e.target.closest('.inner-side-link');
    console.log(innerMenu);
    const button = e.target.closest('button');
    if (!innerMenu) {
      const lineElement = e.target.closest('.-has-links');
      if (lineElement && !lineElement.classList.contains('-has-submenu')) {
        lineElement.classList.add('-has-submenu');
        button.setAttribute('aria-expanded', 'true');
        lineElement.style.maxHeight = `${lineElement.scrollHeight}px`;
      } else {
        lineElement.classList.remove('-has-submenu');
        button.setAttribute('aria-expanded', 'false');
        lineElement.style.maxHeight = '35px';
      }

      const areaLinks = document.querySelectorAll('.-has-links');
      areaLinks.forEach((link) => {
        if (link !== lineElement && link.classList.contains('-has-submenu')) {
          link.classList.remove('-has-submenu');
          link.setAttribute('aria-expanded', 'false');
          // eslint-disable-next-line
          link.style.maxHeight = '35px';
        }
      });
    }
  }
}
domReady(() => {
  LeftMenu.init();
});
